import { Box, Button, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import React from "react";
import { useNavigate } from "react-router";
import Grid from "@mui/material/Grid2";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";

function NoOrdersFound() {
  const navigate = useNavigate();

  return (
    <Box>
      <Typography
        variant="h6"
        gutterBottom
        sx={{
          fontWeight: 700,
          fontSize: "20px",
          lineHeight: "150%",
          color: "var(--neutral-black)",
          textAlign: "left",
        }}
      >
        My Orders
      </Typography>
      <EmptyStateCard>
        <Grid container spacing={2} sx={{ mt: 0 }}>
        <Grid
          size={12}
          sx={{
            textAlign: "center",
            position: "relative",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <DotLottieReact
            src="https://lottie.host/1344cce6-e762-4b23-a610-8f4de87842fb/ehYxxv1uxk.lottie"
            loop
            autoplay
            style={{
              width: "100%",
              height: "100%",
              maxWidth: "350px",
              maxHeight: "350px",
            }}
          />
        </Grid>
        <Grid size={12}>
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              fontWeight: 600,
              fontSize: "20px",
              lineHeight: "150%",
              color: "var(--neutral-black)",
              textAlign: "center",
            }}
          >
            No orders yet
          </Typography>
          <Typography
            variant="h6"
            gutterBottom
            sx={{
              fontWeight: 500,
              fontSize: "16px",
              lineHeight: "150%",
              color: "var(--neutral-700)",
              textAlign: "center",
            }}
          >
            Once you place an order, its dispatch and delivery updates will appear here.
          </Typography>
          <Button
            onClick={() => navigate("/")}
            variant="contained"
            sx={{
              py: 1.5,
              fontSize: "16px",
              height: "48px",
              px: 5,
              mt: 2,
              borderRadius: "999px",
            }}
          >
            Start shopping
          </Button>
        </Grid>
        </Grid>
      </EmptyStateCard>
    </Box>
  );
}

const EmptyStateCard = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(4),
  border: "1px solid rgba(183, 124, 10, 0.22)",
  borderRadius: "18px",
  padding: theme.spacing(3),
  background:
    "linear-gradient(180deg, rgba(255,255,255,0.98) 0%, rgba(255,250,242,0.96) 100%)",
  boxShadow: "0 10px 24px rgba(173, 132, 61, 0.08)",
}));

export default NoOrdersFound;
